<!-- 国际化配置 -->
<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/config/i18n/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('key')">
						<el-input v-model="yt.conditions.key"></el-input>
					</el-form-item>
					<!-- 暂时隐藏 -->
					<!-- <el-form-item :label="$t('yuyan')">
						<yi_dictionary_select :type="'SYSTEM_CONFIG_LANGUAGE'" :ids.sync="yt.conditions.lang">
						</yi_dictionary_select>
					</el-form-item> -->
					<el-form-item :label="$t('zhi')">
						<el-input v-model="yt.conditions.value"></el-input>
					</el-form-item>
					<!-- <el-form-item :label="$t('yingyongduan')">
						<yi_dictionary_select :type="'SYSTEM_AUTH_MENU_PLATFORM'" :ids.sync="yt.conditions.side">
						</yi_dictionary_select>
					</el-form-item> -->
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}</el-button>
						<el-button @click="initI18nToRedis()" type="primary" :loading="loading" plain="plain">
							{{$t('shuaxinhuancun')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
				<el-button size="mini" @click="show = !show" plain>
					{{$t('daoru')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
					@click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template>
			<!-- 自定义某个字段 -->

			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/config/i18n/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('key')" required="required">
						<el-input v-model="yt.editObj.key"></el-input>
					</el-form-item>
					<!-- 应用端下拉选,暂时隐藏不提供筛选,默认为1 -->
					<!-- <el-form-item :label="$t('yingyongduan')" required="required">
						<yi_dictionary_select :type="'SYSTEM_AUTH_MENU_PLATFORM'" :ids.sync="yt.editObj.side" disabled :value='1'>
						</yi_dictionary_select>
					</el-form-item> -->
					<el-form-item :label="$t('zh_CN')" required="required">
						<el-input v-model="yt.editObj.zh_CN"></el-input>
					</el-form-item>
					<el-form-item :label="$t('en_US')">
						<el-input v-model="yt.editObj.en_US"></el-input>
					</el-form-item>
					<el-form-item :label="$t('ru_RU')">
						<el-input v-model="yt.editObj.ru_RU"></el-input>
					</el-form-item>
					<el-form-item :label="$t('de_DE')">
						<el-input v-model="yt.editObj.de_DE"></el-input>
					</el-form-item>
					<el-form-item :label="$t('vi_VN')">
						<el-input v-model="yt.editObj.vi_VN"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/config/i18n/batchCreate',beforAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('key')" required="required">
						<el-input v-model="yt.editObj.key" disabled="true"></el-input>
					</el-form-item>
					<!-- 暂时隐藏 -->
					<!-- <el-form-item :label="$t('yingyongduan')" required="required">
						<yi_dictionary_select :type="'SYSTEM_AUTH_MENU_PLATFORM'" :ids.sync="yt.editObj.side" disabled="true">
						</yi_dictionary_select>
					</el-form-item> -->
					<el-form-item :label="$t('zh_CN')" required="required">
						<el-input v-model="yt.editObj.zh_CN"></el-input>
					</el-form-item>
					<el-form-item :label="$t('en_US')">
						<el-input v-model="yt.editObj.en_US"></el-input>
					</el-form-item>
					<el-form-item :label="$t('ru_RU')">
						<el-input v-model="yt.editObj.ru_RU"></el-input>
					</el-form-item>
					<el-form-item :label="$t('de_DE')">
						<el-input v-model="yt.editObj.de_DE"></el-input>
					</el-form-item>
					<el-form-item :label="$t('vi_VN')">
						<el-input v-model="yt.editObj.vi_VN"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/config/i18n/batchUpdate',beforAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>

		</el-dialog>
		<!-- 导入excel -->
		<import_excel :show.sync="show" />

	</div>
</template>
<script type="text/javascript">
	import import_excel from './import_excel'
	export default {
		components: {
			import_excel,
		},
		name: 'global_lang_list',
		data() {
			return {
				show: false,
				loading: false,
				status: [],
				columns: [{
					label: '#',
					type: 'index',
				}, {
					label: 'key',
					prop: 'key',
				}, {
					label: 'zh_CN',
					prop: 'zh_CN',
				}, {
					label: 'en_US',
					prop: 'en_US',
				}, {
					label: 'ru_RU',
					prop: 'ru_RU',
				}, {
					label: 'de_DE',
					prop: 'de_DE',
				}, {
					label: 'vi_VN',
					prop: 'vi_VN',
				}, {
					label: 'yingyongduan',
					prop: 'side',
					type: 'dictionary',
					key: 'SYSTEM_AUTH_MENU_PLATFORM',
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 150,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.get(1);
				this.getDictCatList();
			}, 300)
			this.utils.event_hub.$on('GLOBAL_LANG_LIST', () => {
				this.yt.get(1);
			})
		},

		methods: {
			initI18nToRedis() {
				this.loading = true;
				let response = this.http.get('/web/config/i18n/initI18nToRedis', {}).then(res => {
					this.$message.success(this.$t(res.msg))
					this.loading = false;
				}).catch(error => {
					this.$message.success(this.$t(error))
					this.loading = false;
				})
			},
			getDictCatList() {
				let response = this.http.get('/web/config/dictType/page', {
					params: {
						pageNum: 1,
						pageSize: 10
					}
				})
				if (response.data) {
					this.dictionaryList = response.data.rows
				}

			},
			replaceParams(value) {
				console.log("value:", value);
				return value != undefined && value != null ? value.replace(/(^\s*)|(\s*$)/g, "") : null;
			},
			beforAdd(params) {
				//先声明一个数组对象
				let reqParams;
				let jsonParams = [];
				jsonParams.push({
					key: this.replaceParams(params.key),
					//side:params.side,  暂时注销
					side: 1, //暂时写死为1:全部
					lang: 1,
					value: this.replaceParams(params.zh_CN),
					createTime: params.createTime,
					updateTime: params.updateTime
				})
				jsonParams.push({
					key: this.replaceParams(params.key),
					//side:params.side, 暂时注销
					side: 1,
					lang: 2,
					value: this.replaceParams(params.en_US),
					createTime: params.createTime,
					updateTime: params.updateTime
				})
				jsonParams.push({
					key: this.replaceParams(params.key),
					//side:params.side,暂时注销
					side: 1,
					lang: 3,
					value: this.replaceParams(params.de_DE),
					createTime: params.createTime,
					updateTime: params.updateTime
				})
				jsonParams.push({
					key: this.replaceParams(params.key),
					//side:params.side,暂时注销
					side: 1,
					lang: 4,
					value: this.replaceParams(params.ru_RU),
					createTime: params.createTime,
					updateTime: params.updateTime
				})
				jsonParams.push({
					key: this.replaceParams(params.key),
					//side:params.side,暂时注销
					side: 1,
					lang: 5,
					value: this.replaceParams(params.vi_VN),
					createTime: params.createTime,
					updateTime: params.updateTime
				})
				return {
					"configI18nVOList": jsonParams
				};
			}
		},
	};
</script>